import { Navigate, useLocation } from 'react-router-dom';
import { legacyResearchLocation } from '@/lib/researchWorkspace';

export default function LegacyResearchRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate replace to={legacyResearchLocation(pathname, search)} />;
}
